function trimWordsEnd(text: string, maxCharacters: number): string {
	if (text.length <= maxCharacters) {
		return text
	}

	const words = text.split(' ')

	if (words[0].length > maxCharacters) {
		return words[0].slice(0, maxCharacters)
	}

	return words
		.reduce((sentence, word) => {
			if (sentence.length + word.length < maxCharacters) {
				return sentence + ' ' + word
			}

			return sentence
		}, '')
		.trim()
}

export default trimWordsEnd
